import { render, staticRenderFns } from "./UpdateRoleAuthModal.vue?vue&type=template&id=05be8378&scoped=true"
import script from "./UpdateRoleAuthModal.vue?vue&type=script&lang=js"
export * from "./UpdateRoleAuthModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateRoleAuthModal.vue?vue&type=style&index=0&id=05be8378&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05be8378",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05be8378')) {
      api.createRecord('05be8378', component.options)
    } else {
      api.reload('05be8378', component.options)
    }
    module.hot.accept("./UpdateRoleAuthModal.vue?vue&type=template&id=05be8378&scoped=true", function () {
      api.rerender('05be8378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/system/components/Modal/UpdateRoleAuthModal.vue"
export default component.exports